// Traduções compartilhadas dos estados do domínio.
export default {
  pt: {
    'status.ticket.draft': 'Rascunho',
    'status.ticket.submitted': 'Enviada',
    'status.ticket.underReview': 'Em análise',
    'status.ticket.approved': 'Aprovada',
    'status.ticket.inProgress': 'Em execução',
    'status.ticket.completed': 'Concluída',
    'status.ticket.cancelled': 'Cancelada',
    'status.shipment.draft': 'Rascunho',
    'status.shipment.awaitingHarvest': 'Aguardando colheita',
    'status.shipment.loading': 'Carregando',
    'status.shipment.awaitingInvoice': 'Aguardando nota',
    'status.shipment.awaitingUnload': 'Aguardando descarga',
    'status.shipment.unloading': 'Descarregando',
    'status.shipment.released': 'Liberado',
    'status.shipment.cancelled': 'Cancelada',
    'status.record.active': 'Ativo',
    'status.record.inactive': 'Inativo',
    'status.record.blocked': 'Bloqueado',
    'status.record.maintenance': 'Manutenção',
    'status.personnel.active': 'Ativo',
    'status.personnel.away': 'Afastado',
    'status.personnel.vacation': 'Férias',
    'status.personnel.dismissed': 'Demitido',
    'status.personnel.blocked': 'Bloqueado',
    'status.contract.active': 'Em andamento',
    'status.contract.closed': 'Finalizado',
    'status.contractSituation.planned': 'Previsto',
    'status.contractSituation.awaitingRelease': 'Aguardando liberação',
    'status.contractSituation.inProgress': 'Em execução',
    'status.contractSituation.completed': 'Finalizado',
    'status.contractSituation.completedWithIssues': 'Finalizado com pendências',
    'status.contractSituation.completedWithIssue': 'Finalizado com pendência',
    'status.contractSituation.halted': 'Paralisado',
    'status.invoice.pending': 'Pendente',
    'status.invoice.requested': 'Solicitada',
    'status.invoice.cancelled': 'Cancelada',
    'status.trip.scheduled': 'Escalado',
    'status.trip.loading': 'Carregando',
    'status.trip.inTransit': 'Trânsito',
    'status.trip.unloading': 'Descarregando',
    'status.trip.attended': 'Atendido',
    'status.trip.unattended': 'Não atendido',
    'status.vp.requested': 'Solicitado',
    'status.vp.notRequested': 'Não solicitado',
    'status.vp.awaitingSync': 'Aguardando sincronização',
    'status.vp.syncError': 'Erro de sincronização',
    'status.transport.inProgress': 'Andamento',
    'status.transport.completed': 'Finalizado',
    'status.transport.reported': 'Apontado',
    'status.transport.scheduledLegacy': 'Apontada',
    'status.transport.inTransitLegacy': 'Trânsito',
    'status.transport.finishedLegacy': 'Finalizado',
    'status.transportVehicle.scheduled': 'Escalado',
    'status.transportVehicle.boarding': 'Embarcando',
    'status.transportVehicle.inTransit': 'Trânsito',
    'status.transportVehicle.available': 'Disponível',
    'status.transporteSituacao.previsto': 'Previsto',
    'status.transporteSituacao.escalado': 'Escalado',
    'status.transporteSituacao.embarcando': 'Embarcando',
    'status.transporteSituacao.transito': 'Trânsito',
    'status.transporteSituacao.finalizado': 'Finalizado',
    'status.transporteSituacao.apontado': 'Apontada',
    'status.fleet.unloading': 'Descarregando',
    'status.fleet.inTransit': 'Trânsito',
    'status.fleet.loading': 'Carregando',
    'status.fleet.available': 'Disponível',
    'status.fleet.onLeave': 'Folga',
    'status.priority.low': 'Baixa',
    'status.priority.normal': 'Normal',
    'status.priority.high': 'Alta',
    'status.priority.urgent': 'Urgente',
    'status.deviation.attended': 'Atendido',
    'status.deviation.rain': 'Chuva no campo',
    'status.deviation.humidity': 'Umidade',
    'status.deviation.machineBroken': 'Máquina quebrada',
    'status.deviation.vehicleBroken': 'Veículo quebrado',
    'status.deviation.noVehicle': 'Falta de veículo',
    'status.deviation.lowYield': 'Baixo rendimento',
    'status.deviation.other': 'Outros',
    'status.unloadingPanel.advancing': 'Adiantando',
    'status.unloadingPanel.available': 'Disponível',
    'status.unloadingPanel.scheduled': 'Escalado',
    'status.unloadingPanel.loading': 'Carregando',
    'status.unloadingPanel.inTransit': 'Em trânsito',
    'status.unloadingPanel.unloading': 'Descarregando',
    'status.unloadingPanel.maintenance': 'Manutenção',
    'status.unloadingPanel.dayOff': 'Folga',
    'status.unloadingPanel.otherSchedule': 'Outros Serviços',
    'status.unloadingPanel.operators': 'Operadores',
    'status.unloadingPanel.away': 'Afastado',
  },
  en: {
    'status.ticket.draft': 'Draft',
    'status.ticket.submitted': 'Submitted',
    'status.ticket.underReview': 'Under review',
    'status.ticket.approved': 'Approved',
    'status.ticket.inProgress': 'In progress',
    'status.ticket.completed': 'Completed',
    'status.ticket.cancelled': 'Cancelled',
    'status.shipment.draft': 'Draft',
    'status.shipment.awaitingHarvest': 'Awaiting harvest',
    'status.shipment.loading': 'Loading',
    'status.shipment.awaitingInvoice': 'Awaiting invoice',
    'status.shipment.awaitingUnload': 'Awaiting unloading',
    'status.shipment.unloading': 'Unloading',
    'status.shipment.released': 'Released',
    'status.shipment.cancelled': 'Cancelled',
    'status.record.active': 'Active',
    'status.record.inactive': 'Inactive',
    'status.record.blocked': 'Blocked',
    'status.record.maintenance': 'Maintenance',
    'status.personnel.active': 'Active',
    'status.personnel.away': 'Away',
    'status.personnel.vacation': 'On vacation',
    'status.personnel.dismissed': 'Dismissed',
    'status.personnel.blocked': 'Blocked',
    'status.contract.active': 'In progress',
    'status.contract.closed': 'Completed',
    'status.contractSituation.planned': 'Planned',
    'status.contractSituation.awaitingRelease': 'Awaiting release',
    'status.contractSituation.inProgress': 'In progress',
    'status.contractSituation.completed': 'Completed',
    'status.contractSituation.completedWithIssues': 'Completed with pending issues',
    'status.contractSituation.completedWithIssue': 'Completed with a pending issue',
    'status.contractSituation.halted': 'Halted',
    'status.invoice.pending': 'Pending',
    'status.invoice.requested': 'Requested',
    'status.invoice.cancelled': 'Cancelled',
    'status.trip.scheduled': 'Scheduled',
    'status.trip.loading': 'Loading',
    'status.trip.inTransit': 'In transit',
    'status.trip.unloading': 'Unloading',
    'status.trip.attended': 'Attended',
    'status.trip.unattended': 'Unattended',
    'status.vp.requested': 'Requested',
    'status.vp.notRequested': 'Not requested',
    'status.vp.awaitingSync': 'Awaiting synchronization',
    'status.vp.syncError': 'Synchronization error',
    'status.transport.inProgress': 'In progress',
    'status.transport.completed': 'Completed',
    'status.transport.reported': 'Reported',
    'status.transport.scheduledLegacy': 'Reported',
    'status.transport.inTransitLegacy': 'In transit',
    'status.transport.finishedLegacy': 'Completed',
    'status.transportVehicle.scheduled': 'Scheduled',
    'status.transportVehicle.boarding': 'Boarding',
    'status.transportVehicle.inTransit': 'In transit',
    'status.transportVehicle.available': 'Available',
    'status.transporteSituacao.previsto': 'Planned',
    'status.transporteSituacao.escalado': 'Scheduled',
    'status.transporteSituacao.embarcando': 'Boarding',
    'status.transporteSituacao.transito': 'In transit',
    'status.transporteSituacao.finalizado': 'Completed',
    'status.transporteSituacao.apontado': 'Reported',
    'status.fleet.unloading': 'Unloading',
    'status.fleet.inTransit': 'In transit',
    'status.fleet.loading': 'Loading',
    'status.fleet.available': 'Available',
    'status.fleet.onLeave': 'On leave',
    'status.priority.low': 'Low',
    'status.priority.normal': 'Normal',
    'status.priority.high': 'High',
    'status.priority.urgent': 'Urgent',
    'status.deviation.attended': 'Attended',
    'status.deviation.rain': 'Rain in field',
    'status.deviation.humidity': 'Humidity',
    'status.deviation.machineBroken': 'Machine broken',
    'status.deviation.vehicleBroken': 'Vehicle broken',
    'status.deviation.noVehicle': 'No vehicle',
    'status.deviation.lowYield': 'Low yield',
    'status.deviation.other': 'Other',
    'status.unloadingPanel.advancing': 'Sent ahead',
    'status.unloadingPanel.available': 'Available',
    'status.unloadingPanel.scheduled': 'Scheduled',
    'status.unloadingPanel.loading': 'Loading',
    'status.unloadingPanel.inTransit': 'In transit',
    'status.unloadingPanel.unloading': 'Unloading',
    'status.unloadingPanel.maintenance': 'Maintenance',
    'status.unloadingPanel.dayOff': 'Day off',
    'status.unloadingPanel.otherSchedule': 'Other Services',
    'status.unloadingPanel.operators': 'Operators',
    'status.unloadingPanel.away': 'Away',
  },
  es: {
    'status.ticket.draft': 'Borrador',
    'status.ticket.submitted': 'Enviada',
    'status.ticket.underReview': 'En revisión',
    'status.ticket.approved': 'Aprobada',
    'status.ticket.inProgress': 'En ejecución',
    'status.ticket.completed': 'Completada',
    'status.ticket.cancelled': 'Cancelada',
    'status.shipment.draft': 'Borrador',
    'status.shipment.awaitingHarvest': 'Esperando cosecha',
    'status.shipment.loading': 'Cargando',
    'status.shipment.awaitingInvoice': 'Esperando factura',
    'status.shipment.awaitingUnload': 'Esperando descarga',
    'status.shipment.unloading': 'Descargando',
    'status.shipment.released': 'Liberado',
    'status.shipment.cancelled': 'Cancelada',
    'status.record.active': 'Activo',
    'status.record.inactive': 'Inactivo',
    'status.record.blocked': 'Bloqueado',
    'status.record.maintenance': 'Mantenimiento',
    'status.personnel.active': 'Activo',
    'status.personnel.away': 'Ausente',
    'status.personnel.vacation': 'De vacaciones',
    'status.personnel.dismissed': 'Desvinculado',
    'status.personnel.blocked': 'Bloqueado',
    'status.contract.active': 'En curso',
    'status.contract.closed': 'Finalizado',
    'status.contractSituation.planned': 'Previsto',
    'status.contractSituation.awaitingRelease': 'Esperando liberación',
    'status.contractSituation.inProgress': 'En ejecución',
    'status.contractSituation.completed': 'Finalizado',
    'status.contractSituation.completedWithIssues': 'Finalizado con pendientes',
    'status.contractSituation.completedWithIssue': 'Finalizado con un pendiente',
    'status.contractSituation.halted': 'Paralizado',
    'status.invoice.pending': 'Pendiente',
    'status.invoice.requested': 'Solicitada',
    'status.invoice.cancelled': 'Cancelada',
    'status.trip.scheduled': 'Programado',
    'status.trip.loading': 'Cargando',
    'status.trip.inTransit': 'En tránsito',
    'status.trip.unloading': 'Descargando',
    'status.trip.attended': 'Atendido',
    'status.trip.unattended': 'No atendido',
    'status.vp.requested': 'Solicitado',
    'status.vp.notRequested': 'No solicitado',
    'status.vp.awaitingSync': 'Esperando sincronización',
    'status.vp.syncError': 'Error de sincronización',
    'status.transport.inProgress': 'En curso',
    'status.transport.completed': 'Finalizado',
    'status.transport.reported': 'Registrado',
    'status.transport.scheduledLegacy': 'Registrada',
    'status.transport.inTransitLegacy': 'En tránsito',
    'status.transport.finishedLegacy': 'Finalizado',
    'status.transportVehicle.scheduled': 'Programado',
    'status.transportVehicle.boarding': 'Embarcando',
    'status.transportVehicle.inTransit': 'En tránsito',
    'status.transportVehicle.available': 'Disponible',
    'status.transporteSituacao.previsto': 'Previsto',
    'status.transporteSituacao.escalado': 'Programado',
    'status.transporteSituacao.embarcando': 'Embarcando',
    'status.transporteSituacao.transito': 'En tránsito',
    'status.transporteSituacao.finalizado': 'Finalizado',
    'status.transporteSituacao.apontado': 'Registrada',
    'status.fleet.unloading': 'Descargando',
    'status.fleet.inTransit': 'En tránsito',
    'status.fleet.loading': 'Cargando',
    'status.fleet.available': 'Disponible',
    'status.fleet.onLeave': 'De descanso',
    'status.priority.low': 'Baja',
    'status.priority.normal': 'Normal',
    'status.priority.high': 'Alta',
    'status.priority.urgent': 'Urgente',
    'status.deviation.attended': 'Atendido',
    'status.deviation.rain': 'Lluvia en el campo',
    'status.deviation.humidity': 'Humedad',
    'status.deviation.machineBroken': 'Máquina averiada',
    'status.deviation.vehicleBroken': 'Vehículo averiado',
    'status.deviation.noVehicle': 'Falta de vehículo',
    'status.deviation.lowYield': 'Bajo rendimiento',
    'status.deviation.other': 'Otros',
    'status.unloadingPanel.advancing': 'Adelantado',
    'status.unloadingPanel.available': 'Disponible',
    'status.unloadingPanel.scheduled': 'Programado',
    'status.unloadingPanel.loading': 'Cargando',
    'status.unloadingPanel.inTransit': 'En tránsito',
    'status.unloadingPanel.unloading': 'Descargando',
    'status.unloadingPanel.maintenance': 'Mantenimiento',
    'status.unloadingPanel.dayOff': 'Descanso',
    'status.unloadingPanel.otherSchedule': 'Otros Servicios',
    'status.unloadingPanel.operators': 'Operadores',
    'status.unloadingPanel.away': 'Ausente',
  },
}
